import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {Category, Forms, QuestionPriority} from "../../constans/formsQuestions";
import {FormMainCategory} from "../../models/forms.model";
import {NavigationStart, Router} from "@angular/router";
import {LoadingMaskServiceService} from "../../components/loading-frame/loading-frame.component";
import {FloatingNotificationService} from "../../shared/floating-notification/floating-notification.service";
import {Subject} from 'rxjs';
import {filter, takeUntil} from 'rxjs/operators';
import {AdvFormService} from './services/adv-form.service';

@Component({
    selector: 'app-create-adv',
    templateUrl: './create-adv.component.html',
    styleUrls: ['./create-adv.component.css'],
    standalone: false
})
export class CreateAdvComponent implements OnInit, AfterViewInit, OnDestroy {

  private readonly destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private loadingMas: LoadingMaskServiceService,
    private notificationService: FloatingNotificationService,
    private formService: AdvFormService
  ) {
    // CreateAdvComponent is instantiated once when entering the publish route.
    // Child navigation to /publish/{category} keeps this component alive, so
    // selections remain available while the user completes the current form.
    this.formService.resetForm();
    this.loadingMas.setOnLoadingMask(true,true)

    this.router.events
      .pipe(
        filter((event): event is NavigationStart => event instanceof NavigationStart),
        takeUntil(this.destroy$)
      )
      .subscribe(event => {
        if (this.normalizePath(event.url) === '/publish' &&
            this.normalizePath(this.router.url) !== '/publish') {
          this.formService.resetForm();
        }
      });
  }
  ngOnInit(): void {
    this.notificationService.loadAll();
    this.notificationService.showByCode('POST_OF_DAY');
  }

  ngAfterViewInit(): void {
    setTimeout(()=>this.loadingMas.setOnLoadingMask(false,false),250)
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private normalizePath(url: string): string {
    const path = (url || '').split('?')[0].split('#')[0].replace(/\/+$/, '');
    return path || '/';
  }

}
